import { API, axiosInstance } from "lib";

export const getCityLocationList = (data={}) => {
  return axiosInstance
    .post(API.GET_LOCATION_LIST , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const createCityLocation = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_LOCATION , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const getCityLocationById = (data={}) => {
  return axiosInstance
    .post(API.GET_LOCATION_BY_ID , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const updateCityLocation = (data = {}) => {
    return axiosInstance
      .post(API.UPDATE_LOCATION, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

export const deleteCityLocationById = (data={}) => {
  return axiosInstance
    .post(API.DELETE_LOCATION , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};